import './EditWhileReadingStyle.css';
import { makeApiRequest, RequestStatus } from "../../../../api_request/api_request";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { bookReaderActions } from "../slice";
import { useLocation, useNavigate } from "react-router-dom";
import { restActions } from "../../../../rest/slice";
import { Button } from "../../../RequestRespectingInputs";
import { useEffect, useState } from "react";

export function EWRSetBookmarkButton(params: Params)
{
    const appDispatch = useAppDispatch();
    const {sentenceId} = params;
    const bookId = useAppSelector((state) => state.bookReader.book?.id);
    const checkRequestStatus = useAppSelector((state) => sentenceId === state.bookReader.sentenceForLastSetBookmarkAttempt );

    const location = useLocation();
    const navigate = useNavigate();
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    const [classForRequestStatus, setClassForRequestStatus] = useState('');
    const elmClass = `ernots_EWRSetBookmarkButton ${classForRequestStatus}`;

    async function setBookmark()
    {
        const url = `book/${encodeURIComponent(bookId)}/set_bookmark/${encodeURIComponent(sentenceId)}/`;
        await makeApiRequest({
            endpoint: url,
            method: 'PATCH',
            dispatch: appDispatch,
            lifeCycleCallback: setRequest
        });

        appDispatch(bookReaderActions.setSentenceForLastSetBookmarkAttempt(sentenceId));
    }

    useEffect(function()
    {
        if (!checkRequestStatus || !request)
        {
            setClassForRequestStatus('');
            return;
        }
        
        if (request.finished)
        {
            if (request.success)
            {
                appDispatch(bookReaderActions.setBookmark(sentenceId));
                appDispatch(restActions.setBookmark({bookId, sentenceId}));
    
                const searchParams = new URLSearchParams(location.search);
                searchParams.set('bookmark', (sentenceId + 1) + '');
                
                const to = 
                {
                    pathname: location.pathname,
                    search: searchParams + ''
                }
                navigate(to, {replace: true});
    
                setClassForRequestStatus('ernots_EWRSetBookmarkButton_Success');
            }
            else
            {
                setClassForRequestStatus('ernots_EWRSetBookmarkButton_Error');
            }
        }
        else
        {
            setClassForRequestStatus('ernots_EWRSetBookmarkButton_Pending');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkRequestStatus, request?.finished, request?.success]);
    
    return (
        <Button
                className={elmClass}
                onClick={e => setBookmark()}
                title="Set a bookmark on this sentence. The next time you open this book, it will jump to this location.">
            Bookmark
        </Button>);
}

interface Params
{
    sentenceId: number;
}